import { readMiniTaskSoundEnabled } from '../../mini-tasks/soundEffects';

// A small bell phrase, deliberately separate from the tournament fanfare.
// Warm up in the confirmation gesture; never queue playback behind autoplay permission.
let context;
export function prepareAppreciationSound() {
  try {
    if (!readMiniTaskSoundEnabled()) return;
    const Audio = window.AudioContext || window.webkitAudioContext;
    if (!Audio) return;
    if (!context || context.state === 'closed') context = new Audio();
    if (context.state === 'suspended') context.resume()?.catch(() => {});
  } catch (_) { /* Sound must never interrupt saving an award. */ }
}

export function playAppreciationSound() {
  if (!readMiniTaskSoundEnabled() || context?.state !== 'running') return () => {};
  const nodes = [];
  let output;
  const stop = () => {
    nodes.forEach(node => { try { node.stop(); node.disconnect(); } catch (_) { /* Already ended. */ } });
    output?.disconnect();
  };
  try {
    output = context.createGain();
    output.gain.value = 0.55;
    output.connect(context.destination);
    const start = context.currentTime + 0.015;
    // C–E–G, then a gentle E–G–C sparkle. The phrase finishes in .88 s;
    // only the soft final bell decay continues to 2.4 s.
    [[523.25, 0, .45], [659.25, .16, .5], [783.99, .32, .55],
      [659.25, .56, .6], [783.99, .72, .7], [1046.5, .88, 1.5]].forEach(([frequency, offset, duration]) => {
      [1, 2].forEach(harmonic => {
        const oscillator = context.createOscillator();
        nodes.push(oscillator);
        const envelope = context.createGain();
        oscillator.type = 'sine';
        oscillator.frequency.value = frequency * harmonic;
        envelope.gain.setValueAtTime(.0001, start + offset);
        envelope.gain.exponentialRampToValueAtTime(harmonic === 1 ? .09 : .012, start + offset + .018);
        envelope.gain.exponentialRampToValueAtTime(.0001, start + offset + duration);
        oscillator.connect(envelope); envelope.connect(output);
        oscillator.start(start + offset); oscillator.stop(start + offset + duration);
        oscillator.onended = () => { oscillator.disconnect(); envelope.disconnect(); };
      });
    });
    nodes[nodes.length - 1].addEventListener('ended', () => output.disconnect(), { once: true });
  } catch (_) { stop(); }
  return stop;
}
